import { useTypedParams } from '@sorare/routing';

import { Position } from '@sorare/core/src/__generated__/globalTypes';

import { RequestLineupForm } from '@sorare/gameplay/src/components/noCardRoute/RequestLineupForm';
import { disclaimerMessages } from '@sorare/gameplay/src/lib/noCardRoute';

import { PageParams } from './__generated__/routeParams';

const slotRounds = [[0], [1, 2, 3, 4], [5], [6]];
const lineups = [
  {
    positions: [Position.baseball_starting_pitcher],
    label: 'Starting Pitcher',
  },
  {
    positions: [Position.baseball_relief_pitcher],
    label: 'Relief Pitcher',
  },
  {
    positions: [
      Position.baseball_first_base,
      Position.baseball_third_base,
      Position.baseball_designated_hitter,
    ],
    label: 'Corner Infielder',
  },
  {
    positions: [
      Position.baseball_second_base,
      Position.baseball_catcher,
      Position.baseball_shortstop,
    ],
    label: 'Middle Infielder',
  },
  {
    positions: [Position.baseball_outfield],
    label: 'Outfielder',
  },
  {
    positions: [
      Position.baseball_first_base,
      Position.baseball_third_base,
      Position.baseball_designated_hitter,
      Position.baseball_second_base,
      Position.baseball_catcher,
      Position.baseball_shortstop,
      Position.baseball_outfield,
    ],
    label: 'Hitter',
  },
  {
    positions: [
      Position.baseball_first_base,
      Position.baseball_third_base,
      Position.baseball_designated_hitter,
      Position.baseball_second_base,
      Position.baseball_catcher,
      Position.baseball_shortstop,
      Position.baseball_outfield,
    ],
    label: 'Flex',
  },
];

const NoCardEntry = () => {
  const { so5FixtureId } = useTypedParams<PageParams>();

  return (
    <RequestLineupForm
      so5FixtureId={so5FixtureId}
      slotRounds={slotRounds}
      lineup={lineups}
      disclaimers={[
        disclaimerMessages.eligibilityCheck,
        disclaimerMessages.leaderboardSelection,
      ]}
    />
  );
};

export default NoCardEntry;
